import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

const RightArrowCircleIcon = ( {className}: PropsType ): React.ReactElement => (
    <SvgWrapper width={18} height={18} fill='#fff' className={className} viewBox='0 0 18 18' xmlSpace='preserve'>
        <path
            fill='#fill'
            d='M9 0a9 9 0 110 18A9 9 0 019 0zm0 2a7 7 0 100 14A7 7 0 009 2zm.813 3.21l.094.083 3 3a1.006 1.006 0 01.147.186l.021.037c.011.02.022.04.031.06l.023.053a.988.988 0 01.06.223l.007.062.001.026v-.016l.001.017.001.027v.066a1.011 1.011 0 01-.07.337l-.023.052a1.018 1.018 0 01-.102.172l-.025.03c.004-.002.002-.001.001 0l-.013.015-.01.013-.05.054-3 3a1 1 0 01-1.497-1.32l.083-.094L9.785 10H5a1 1 0 01-.993-.883L4 9a1 1 0 01.883-.993L5 8h4.785L8.493 6.707a1 1 0 01-.083-1.32l.083-.094a1 1 0 011.32-.083zm3.166 4.415l-.072.082.06-.067.012-.015z'
            fillRule='evenodd'
        />
    </SvgWrapper>
);

export default RightArrowCircleIcon;
